import { useNavigate } from 'react-router-dom';
import { SVGAssets } from '@business/assets/vectors';
import { Button } from '../Button';

export const HeadingWithBack: React.FC<{
  title: string;
}> = ({ title }) => {
  const navigate = useNavigate();

  return (
    <Button
      btnStyle="link"
      className="flex gap-3 items-center"
      onClick={() => {
        navigate(-1);
      }}>
      <SVGAssets.PricingArrow className="w-2 mr-2 text-black" />
      <h2 className="text-lg font-semibold text-gray-800">{title}</h2>
    </Button>
  );
};
